
import { Component, Inject, OnInit, ViewChild, DOCUMENT } from '@angular/core';
import { UntypedFormControl, NgForm, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ToastButtons, ToastMessageType, ToastService } from '../../../../../Common/toast';
import { TenantService } from '../../../../../Services/tenant.service';
import { CustomFieldsService } from '../../Services/customfields.service';
import {
    ColumnMapping,
    CustomMapping,
    FormatViewModel,
    ImportService,
    NewImportViewModel,
    NodeError,
    RawRow,
    ValidationResult
} from '../../Services/import.service';
import { ModuleService } from '../../Services/module.service';
import { MessageJobSeverity } from '@app/Enums';
import { NgClass } from '@angular/common';
import { MatCard, MatCardTitle, MatCardContent, MatCardSubtitle, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatBadge } from '@angular/material/badge';
import { CustomFieldValidatorDirective } from './custom-field-validator.directive';
import { JobLiveViewComponent } from '../../../../../Jobs/job.liveview.component';

@Component({
    selector: 'aw-historical-data-import',
    templateUrl: './historical-data-import.component.html',
    styleUrls: ['./historical-data-import.component.scss'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatButton, MatIcon, MatCardSubtitle, MatFormField, MatSelect, FormsModule, MatOption, MatCheckbox, NgClass, ExtendedModule, MatInput, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatBadge, CustomFieldValidatorDirective, MatError, MatCardActions, JobLiveViewComponent]
})
export class HistoricalDataImportComponent implements OnInit {
    @ViewChild('mappingForm') mappingForm: NgForm;
    hasReleases: false;
    importType = 'historicaldata';
    viewModel: NewImportViewModel;
    filename: string;
    busy: boolean;
    busyMessage: string;
    fileError: string;
    importResult: ValidationResult;
    selectedModuleId: string;
    selectedStateId: string;
    error: NodeError;
    provisioningJob: string;
    hasMappings: boolean;
    version = 0;
    selectOptions: any[] = [];
    customHeaders: ColumnMapping[] = [];
    customArrIndex: number;
    customHeaderIndex: number;
    customFieldMappingId: number;
    MappingNameFromId: any[] = [];
    customFieldMappingName: string;
    moduleContent: any;
    expandMappings = true;
    showTemplateNameField: boolean = null;
    showMappings: boolean;
    mappingsError: string;
    customFieldName: string;
    customFieldPropertyNames: ColumnMapping[] = [];
    noExtraFieldsInFile: boolean;
    customFieldMappingControl: UntypedFormControl;
    customMapping: CustomMapping;
    result: any;
    file: any;
    moduleContent$: Subject<any> = new Subject<any>();
    availableFormats: FormatViewModel[];
    selectedFormatId: number;
    selectedFormat: FormatViewModel;
    selectedFileFormat: any;
    customFieldMappings: any[];
    showErrors: boolean[] = [];
    expectedHeaders: string[];
    tenantName: string;

    constructor(
        private tenantService: TenantService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private importService: ImportService,
        private moduleService: ModuleService,
        private customFieldService: CustomFieldsService,
        private toast: ToastService,
        @Inject(DOCUMENT) private document: Document) {
    }

    ngOnInit(): void {
        const tenant = this.tenantService.selectedTenant;
        this.hasMappings = false;
        this.importService.getNewViewModel(this.importType, tenant.TenantId)
            .subscribe(
                r => {
                    this.viewModel = r;
                });
        this.moduleContent$.subscribe(_moduleContent => {
            this.moduleContent = _moduleContent;
            });

        this.tenantName = tenant.Value;
    }

    ngDoCheck() {

    }

    jobComplete(event: MessageJobSeverity) {
        if (event === MessageJobSeverity.Success) {
            console.log('File imported successfully');
        }
    }

    canValidate() {
        if (this.noExtraFieldsInFile) {
            return true;
        } else {
            if (!this.customFieldMappingId) {
                return true;
            }
            return this.mappingForm.valid && !this.mappingForm.dirty;
        }
    }


    setModule(e: any) {
        this.resetViewModel();

        if (e.value) {
            this.getModules(e.value);
            this.viewModel.SelectedModuleId = e.value;
            this.importService.getFormats(this.importType, this.tenantService.selectedTenant.TenantId, e.value)
                .subscribe(r => {
                    this.availableFormats = r;
                });
            this.importService.getImportStates(this.tenantService.selectedTenant.TenantId, e.value)
                .subscribe(r => {
                    this.viewModel.AvailableStates = r;
                });
            this.customFieldService.getMappings(this.tenantService.selectedTenant.TenantId, e.value)
                .subscribe(c => {
                    this.customFieldMappings = c;
                });
        }
    }

    setMultiFieldName(e: any) {
        // this is needed to make the change immutable to the change listeners register the
        // fact that they need to do something.
        this.customFieldPropertyNames = [...this.customFieldPropertyNames];
    }

    validateDuplicateValues(val: any) {
        if (this.customFieldPropertyNames.filter(cfp => cfp.PropertyName == val && cfp.PropertyName != null
            && cfp.PropertyName != '').length > 1) {
            return true;
        }
        return false;
    }

    getModules(moduleId): void {
        this.moduleService.getCurrentModuleVersion(this.tenantService.selectedTenant, moduleId)
            .then(moduleVersion => {
                this.version = moduleVersion;
                this.getModuleContent().then((res) => {
                    this.moduleContent$.next(res);
                });
            });
    }

    setButton(e: any) {
        if (e.value) {
            this.viewModel.SelectedStateId = e.value;
        }
    }

    updateSelectedFormat() {
        this.selectedFormat = this.availableFormats.filter(x => x.Id === this.selectedFormatId).pop();
        return true;
    }

    getSelectedFormat() {
        this.updateSelectedFormat();
        return this.importService.getFormat(this.selectedFormatId);
    }

    remapCustomFields() {
        this.mappingForm.form.markAsPristine();
        if (this.AddCustomFields()) {
            this.mappingForm.form.markAsDirty();
        }
        this.openMappings();
        this.displayMappings();
        //this.matchHeaders();
        this.hasMappings = true;
    }

    refreshCustomFields() {
        this.importService
            .uploadFile(
                this.file,
                this.importType, this.selectedFormat,
                this.viewModel.Id,
                this.selectedModuleId,
                this.filename,
                this.customFieldMappingId
            )
            .subscribe((data: NewImportViewModel) => {
                this.busy = false;
                this.viewModel = {
                    ...this.viewModel,
                    ...(data as NewImportViewModel)
                };

                this.availableFormats = data.Formats;

                if (!data.FormatError) {
                    this.remapCustomFields();
                    this.showMappings = true;
                } else {
                    this.showMappings = false;
                }

                this.getSelectedFormat().subscribe(selectedFormat => {
                    this.expectedHeaders = selectedFormat.Mappings.map(mapping => mapping.PropertyName);
                });
            },
                error => {
                    console.log(error);
                    this.busy = false;
                    this.fileError = 'File was not the correct format';
                });
    }

    previewFile(e: any) {
        const files: FileList = e.target.files;
        this.file = files[0];
        this.filename = this.file.name;
        this.busy = true;
        this.busyMessage = 'Uploading file';
        this.fileError = null;
        this.refreshCustomFields();
    }

    private removeDuplicates(arr: any[]): any[] {
        const unique = [];
        arr.forEach(item => {
            if (unique.some((u: any) => u.Key === item.Key && u.MultiFieldName === item.MultiFieldName)) {
                return;
            }
            unique.push(item);
        });
        return unique;
    }

    private makeKeysUnique(arr: any[]): any[] {
        const result = arr.map((item: any) => {
            let prefix = '';
            if (item.MultiFieldName) {
                prefix = item.MultiFieldName + '.';
            }
            item.Key = prefix + item.Key;
            return item;
        });
        return result;
    }

    private getCustomFieldsForModule(): any[] {
        const _customFields: any[] = [];
        let multiFieldName;

        this.moduleContent.Steps.forEach((step) => {
            multiFieldName = step.MultiFieldName;
            step.Fields.forEach((field) => {
                if (field.IsCustomField) {
                    field.MultiFieldName = multiFieldName;
                    _customFields.push(field);
                }
            });
            multiFieldName = null;
        });
        return _customFields;
    }

    private AddCustomFields(): boolean {
        let dirty = false;
        this.selectOptions = [];
        this.customFieldPropertyNames = [];

        let customFieldsForModule: any[];

        // filter out calculated fields
        customFieldsForModule = this.getCustomFieldsForModule().filter(customField => customField.FieldType !== 'calc');


        customFieldsForModule.forEach(field => this.selectOptions.push({
            Key: field.FieldId,
            Value: field.FieldName,
            MultiFieldName: field.MultiFieldName
        }));

        this.selectOptions = this.removeDuplicates(this.selectOptions);
        this.selectOptions = this.makeKeysUnique(this.selectOptions);

        this.excelCustomHeaders();

        const cfs: any[] = this.viewModel.ImportMapping.Mappings.filter(c => c.IsCustomField == true);

        const matchedCustomFields: ColumnMapping[] = [];
        const orphanedMappings: ColumnMapping[] = [];

        cfs.forEach((cf: any) => {
            const propertyName = cf.PropertyName;
            const multiFieldName = cf.MultiFieldName;
            const key = multiFieldName ? multiFieldName + '.' + propertyName : propertyName;

            const ch = this.customHeaders.find(x => x.InputColumnName === cf.InputColumnName);
            if (ch) {
                if (cf.InputColumnsIndex !== ch.InputColumnsIndex) {
                    cf.InputColumnsIndex = ch.InputColumnsIndex;
                    dirty = true;
                }
                matchedCustomFields.push({
                    InputColumnsIndex: ch.InputColumnsIndex,
                    IsCustomField: true,
                    PropertyName: key,
                    InputColumnName: cf.InputColumnName,
                    TypeName: cf.TypeName,
                    MultiFieldName: cf.MultiFieldName
                });
            } else {
                orphanedMappings.push({
                    InputColumnsIndex: null,
                    IsCustomField: true,
                    PropertyName: key,
                    InputColumnName: cf.InputColumnName,
                    TypeName: cf.TypeName,
                    MultiFieldName: cf.MultiFieldName
                });
            }
        });
        this.customHeaders.forEach((ch) => {
            const foundCustomField = matchedCustomFields.find(x => x.InputColumnName === ch.InputColumnName);
            if (!foundCustomField) {
                matchedCustomFields.push({
                    InputColumnsIndex: ch.InputColumnsIndex,
                    IsCustomField: true,
                    PropertyName: null,
                    InputColumnName: ch.InputColumnName,
                    TypeName:
                        'Airsweb.Utilities.FileImport.ImportModuleRow, Airsweb.Utilities.FileImport, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
                    MultiFieldName: null
                });
            }
        });
        const max = matchedCustomFields.reduce((acc, cur) => acc > cur.InputColumnsIndex ? acc : cur.InputColumnsIndex, 0);
        orphanedMappings.forEach((x, i) => x.InputColumnsIndex = max + (i + 1));
        this.customFieldPropertyNames = [...matchedCustomFields.sort((a: any, b: any) => a.InputColumnsIndex - b.InputColumnsIndex), ...orphanedMappings];
        return dirty;
    }

    validate(includeAllErrors: boolean, includeValidRowsInReport: boolean) {
        this.expandMappings = true;
        this.busy = true;
        this.busyMessage = 'Validating the structure of the file';
        this.importService.validateHistoricalData(this.viewModel.Id, this.selectedModuleId, this.selectedStateId, this.customFieldMappingId, includeAllErrors, includeValidRowsInReport)
            .subscribe(r => {
                this.viewModel = r;
                this.busy = false;
            });
    }

    getFieldClass(r: RawRow, i: number) {
        return r.Errors.filter(e => e.ColumnIndex === i).length > 0
            ? 'error'
            : '';
    }

    showAsError(f: boolean) {
        return f ? 'error' : '';
    }

    hasErrors() {
        if (!this.viewModel) {return false;}
        return (this.viewModel.ErrorRows && this.viewModel.ErrorRows.length > 0) ||
            (this.viewModel.NodeErrors && this.viewModel.NodeErrors.length > 0) ||
            this.viewModel.Failed;
    }

    import() {
        this.busy = true;
        this.busyMessage = `Importing ${this.viewModel.Title}...`;

        this.additionalValues = {
            moduleId: this.selectedModuleId,
            importState: this.selectedStateId
        };

        this.importService.beginImport(this.viewModel.Id, this.filename, this.additionalValues)
            .subscribe(r => {
                this.importResult = r;
                this.provisioningJob = r.Model;
                console.log('PROVISIONING JOB', r);
                this.busy = false;
            });
    }

    lists = {};
    additionalValues = {};

    getListItems(vals: string[]) {
        if (!this.lists[`${vals[0]}_${vals[1]}`]) {
            this.lists[`${vals[0]}_${vals[1]}`] = [];
            this.tenantService.getListItems(vals)
                .subscribe(r => this.lists[`${vals[0]}_${vals[1]}`] = r);
        }
        return this.lists[`${vals[0]}_${vals[1]}`];
    }
    listLoaded(vals: string[]) {
        return this.lists[`${vals[0]}_${vals[1]}`] && this.lists[`${vals[0]}_${vals[1]}`].length > 0;
    }

    showFileFormatCard() {
        return this.viewModel.SelectedModuleId && this.viewModel.SelectedStateId;
    }

    resetViewModel() {
        this.selectedFormatId = null;
        this.viewModel.ValidationComplete = null;
        this.viewModel.SelectedModuleId = null;
        this.viewModel.SelectedStateId = null;
        this.filename = null;
        this.viewModel.Top5Rows = null;
        this.viewModel.ImportLocation = null;
        this.customFieldMappingId = null;
        this.showTemplateNameField = null;
        this.showMappings = false;
        this.file = null;
    }

    checkLength(importLocation: string) {
        if (importLocation === null)
            {return false;}

        return importLocation.length >= 5;
    }

    disableImportButton() {
        for (const additionalSettings in this.viewModel.AdditionalSettings) {
            const isMandatory = this.viewModel.AdditionalSettings[additionalSettings].Mandatory;
            const additionalValue = this.additionalValues[this.viewModel.AdditionalSettings[additionalSettings].PropertyName];
            if (isMandatory && additionalValue == undefined) {return true;}
        }
        return this.viewModel.Failed || this.mappingForm.dirty || this.busy;
    }

    disableFileScanButton() {
        if (this.viewModel.ImportLocation == null || this.viewModel.ImportLocation.length < 5) {
            return true;
        }
        else if (this.viewModel.SelectedModuleId == null) {
            return true;
        }
        return false;
    }

    showValidateButton() {
        return (this.viewModel.Top5Rows && this.viewModel.Top5Rows.length > 0 &&
            !this.viewModel.ValidationComplete)
            ||
            this.viewModel.ValidationError;
    }

    getModuleContent(): Promise<any> {
        return this.moduleService.loadModuleContent(this.tenantService.selectedTenant, this.selectedModuleId, this.version);
    }

    saveMapping(mappingForm: NgForm) {
        if (!mappingForm.valid) {
            this.toast.sendMessage('Mappings Not Valid',
                'Please make sure there are no errors and try again.',
                ToastMessageType.warning,
                ToastButtons.None);
            return;
        }
        const propsToSave = this.customFieldPropertyNames.filter(x => x.PropertyName != null);
        const mappingsToSave: ColumnMapping[] = [];
        propsToSave.forEach(cf => {
            const mapping = { ...cf };
            if (mapping.PropertyName.indexOf('.') > 0) {
                const props = mapping.PropertyName.split('.');
                mapping.PropertyName = props[1];
                mapping.MultiFieldName = props[0];
            }
            mappingsToSave.push(mapping);
        });
        if (this.customFieldName != null) {
            this.customMapping = {
                Id: 0,
                Name: this.customFieldName,
                ModuleId: this.selectedModuleId,
                TenantId: this.tenantService.selectedTenant.TenantId,
                ColumnMappings: mappingsToSave
            };
        } else {
            this.MappingNameFromId = this.customFieldMappings.filter(n => n.Id == this.customFieldMappingId);
            this.customFieldMappingName = this.MappingNameFromId[0].Name;
            this.customMapping = {
                Id: this.customFieldMappingId,
                Name: this.customFieldMappingName,
                ModuleId: this.selectedModuleId,
                TenantId: this.tenantService.selectedTenant.TenantId,
                ColumnMappings: mappingsToSave
            };
        }
        this.customFieldService.updateMappings(this.customMapping).subscribe((id: number) => {
            this.toast.sendMessage('Saved', 'Successfully saved ' + name, ToastMessageType.success);
            this.mappingForm.form.markAsPristine();
            if (this.customMapping.Id === 0) {
                this.customMapping.Id = id;
                this.customFieldMappings.push(this.customMapping);
                this.showTemplateNameField = false;
                this.customFieldMappingId = this.customMapping.Id;
            }
            this.refreshCustomFields();
        });
    }

    downloadTemplate() {
        this.getSelectedFormat().subscribe(format => {
            const rows = format.Mappings.sort((a, b) => a.InputColumnsIndex - b.InputColumnsIndex).map(mapping => '"' + mapping.PropertyName + '"');
            const csvContent = 'data:text/csv;charset=utf-8,' + rows.join(',');
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            const filename = this.selectedFormat.Name.replace(/[\s\\]/gi, '');
            link.setAttribute('download', `${this.tenantService.selectedTenant.Value}_${filename}.csv`);
            this.document.body.appendChild(link);
            link.click();
        });
    }

    collapseMappings() {
        this.expandMappings = true;
    }

    changeCollapseMappings() {
        if (this.expandMappings == true) {
            this.expandMappings = false;
        } else {
            this.expandMappings = true;
        }
    }
    openMappings() {
        if (this.customFieldPropertyNames.filter(cfp => cfp.PropertyName != null || cfp.PropertyName != '').length > 1) {
            this.expandMappings = false;
        }
    }
    displayMappings() {
        if (this.viewModel.HeaderRows.Fields.length == this.customArrIndex) {
            this.mappingsError = 'No Extra Fields Within The File Available To Map.';
            this.noExtraFieldsInFile = true;
            this.showMappings = false;
        } else {
            this.showMappings = true;
            this.noExtraFieldsInFile = false;
        }
    }
    excelCustomHeaders() {
        this.customHeaders = [];
        this.customHeaderIndex = this.viewModel.HeaderRows.Fields.length;
        this.customArrIndex = this.viewModel.ImportMapping.Mappings.filter(m => m.IsCustomField == false).length;
        for (let i = this.customArrIndex; i < this.customHeaderIndex; i++) {
            this.customHeaders.push({
                InputColumnsIndex: i,
                InputColumnName: this.viewModel.HeaderRows.Fields[i],
                IsCustomField: true,
                PropertyName: null,
                TypeName: null,
                MultiFieldName: null
            });
        }
    }
    addNewMapping() {
        this.showTemplateNameField = true;
    }
    toggleMappingButton(showTemplateName: boolean) {
        this.showTemplateNameField = showTemplateName;
        if (showTemplateName == true) {
            this.customFieldMappingId = undefined;
            this.expandMappings = false;
        } else {
            this.customFieldName = null;
        }
    }

    downloadErrorFile(viewModelId: number) {
        this.importService.getErrorReportFile(viewModelId)
            .subscribe(r => {
                const blob = new Blob([r], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);
            })
    }
}
